import React, { useEffect, useState, useRef } from 'react';
import { manage, run, releaseChildren } from '.';
export class Component extends React.Component {
    propsProxy;
    isTrigger;
    constructor(props) {
        super(props);
        // rewrite render()
        const render = this.render.bind(this);
        this.render = () => {
            this.dispose();
            this.propsProxy = manage(this.props);
            const [result, isTrigger] = run(this.propsProxy, render);
            this.isTrigger = isTrigger;
            this.propsProxy.$e.on('event', this.listener);
            return result;
        };
        // rewrite componentWillUnmount()
        const componentWillUnmount = this.componentWillUnmount ? this.componentWillUnmount.bind(this) : () => { };
        this.componentWillUnmount = () => {
            this.dispose();
            componentWillUnmount();
        };
    }
    listener = (event) => {
        if (this.isTrigger(event)) {
            this.forceUpdate();
        }
    };
    dispose() {
        if (this.propsProxy) {
            releaseChildren(this.propsProxy);
            this.propsProxy.$e.off('event', this.listener);
            this.propsProxy = undefined;
        }
    }
}
export const auto = (render, props) => {
    const prev = useRef();
    if (prev.current) {
        prev.current();
    }
    useEffect(() => {
        prev.current = () => {
            releaseChildren(proxy);
            proxy.$e.off('event', listener);
        };
    });
    const proxy = manage(props);
    const [result, isTrigger] = run(proxy, render);
    const [, refresh] = useState(false);
    const listener = (event) => {
        if (isTrigger(event)) {
            refresh((r) => !r);
        }
    };
    proxy.$e.on('event', listener);
    return result;
};
